// CONCEPT — juridisch te laten toetsen vóór publieke lancering (zie docs/PRIVACY.md).
export function PrivacyPage() {
  return (
    <article className="prose stack">
      <h1>Privacy &amp; voorwaarden</h1>
      <p className="note">Concepttekst voor de bètafase.</p>

      <h2>Welke boeken je mag uploaden</h2>
      <p>
        Alleen boeken die je rechtmatig hebt verkregen, voor privégebruik, of waarvoor je
        toestemming hebt van de rechthebbende, of die in het publieke domein zijn. Bij elke upload
        bevestig je de verklaring; de versie en het tijdstip worden vastgelegd. Zie de{" "}
        <a href="#/voorwaarden">gebruiksvoorwaarden</a>.
      </p>

      <h2>Wat we bewaren</h2>
      <ul>
        <li>
          Je account: e-mailadres en naam van je login, status, toegekende credits en het land
          dat je zelf opgeeft.
        </li>
        <li>
          Het geüploade bestand: alleen tijdens de verwerking; daarna wordt het verwijderd. De
          hoofdstuktekst die tussen de verwerkingsstappen nodig is, wordt uiterlijk na 24 uur
          verwijderd. (Verwijderde bestanden zijn bij onze opslagdienst nog 7 dagen herstelbaar
          ter bescherming tegen vergissingen, daarna definitief weg.)
        </li>
        <li>
          Wat uit je boek is afgeleid: personages, feiten, korte samenvattingen en per feit een
          kort citaat dat alleen jij bij het controleren ziet. Boeken zijn privé: alleen jij ziet
          de inhoud, ook beheerders niet.
        </li>
        <li>
          Een vingerafdruk (hash) van het bestand en de uitkomst van de automatische
          herkomstcontrole, om hetzelfde bestand te herkennen (opnieuw aanbieden, of na een
          gegronde melding blokkeren).
        </li>
        <li>Verwerkingsgegevens: status en kosten van de verwerking.</li>
      </ul>

      <h2>Waarvoor en met wie</h2>
      <p>
        De tekst van je boek wordt per hoofdstuk naar een taalmodel (standaard DeepSeek) gestuurd om
        personages en gebeurtenissen te herkennen; die verwerking vindt plaats buiten de EU. Kies je bij het
        uploaden voor Mistral AI (experimenteel), dan gebeurt de verwerking in de EU.
        Je accountgegevens worden daarbij niet meegestuurd. Opslag en hosting gebeuren bij Google Cloud
        (EU) en Aiven (database, EU). Inloggen verloopt via Auth0.
      </p>

      <h2>Meldingen</h2>
      <p>
        Doe je een <a href="#/melden">melding</a>, dan bewaren we je naam, e-mailadres en de
        melding om die te behandelen en je te antwoorden. De uploader krijgt alleen de motivering,
        niet jouw gegevens.
      </p>

      <h2>Jouw rechten</h2>
      <p>
        Onder <a href="#/">Mijn boeken → Mijn account</a> download je al je accountgegevens of
        verwijder je je account. Verwijderen wist je account, je boeken, alle afgeleide gegevens
        en de geüploade bestanden.
      </p>
    </article>
  );
}
